import api from '@/api/API';
import { ExternalClient } from '@/types';

export default {
  findAll(agencyId: string): Promise<ExternalClient[]> {
    return api
      .get(`agencies/${agencyId}/clients/external`)
      .then(response => response.data);
  },
};
